import { isNationAMember } from './member';

const STAG_LOGGING_VALID_EMAIL = 'test@nation-a.com';

const ENV_MODE = {
  dev: 'development',
  prod: 'production',
  staging: 'staging',
};
export const isEventLoggingValid = (email: string) => {
  const currEnvMode = import.meta.env.MODE;

  if (currEnvMode.includes(ENV_MODE.dev)) return false;
  if (
    currEnvMode.includes(ENV_MODE.staging) &&
    email !== STAG_LOGGING_VALID_EMAIL
  )
    return false;
  if (currEnvMode.includes(ENV_MODE.prod) && isNationAMember(email))
    return false;

  return true;
};
